var map = {
	"./chania.jpg": "1802",
	"./cosmoplay.jpg": "e3f9",
	"./cosmotebooks.jpg": "a4fb",
	"./default.jpg": "278c",
	"./emtecom.jpg": "9566",
	"./feelmusic.jpg": "819c",
	"./floods.ypeka.jpg": "6682",
	"./helmi.jpg": "1621",
	"./keema.jpg": "c4d0",
	"./litcom.jpg": "8b37",
	"./litcom_box.png": "c686",
	"./matoufrance.jpg": "c719",
	"./mindjam.jpg": "336d",
	"./troxaia.jpg": "a833"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0ec8";